<script setup>
import { inject } from 'vue';

const isInDialog = inject('isInDialog', false);
</script>

<template>
    <div
        class="flex flex-col gap-4"
        :class="{
            'p-4': isInDialog,
        }"
    >
        <slot />
    </div>
</template>
